.addExtensionButton:global(.MuiButton-root) {
	height: 35px;
	min-width: fit-content;
	width: 100px;
}

.extensionName:global(.MuiTypography-root) {
	color: #333333;
	font-weight: 400;
	font-size: 0.875rem;
	line-height: 1.6;
	letter-spacing: 0;
	white-space: nowrap;
	overflow: hidden;
	text-overflow: ellipsis;
	min-width: 0;
	flex: 0 1 auto;
}

.extensionId:global(.MuiTypography-root) {
	color: #676767;
	font-weight: 400;
	line-height: 1.6;
	letter-spacing: 0;
	font-size: 0.875rem;
	white-space: nowrap;
	overflow: hidden;
	text-overflow: ellipsis;
	min-width: 0;
	flex: 0 1 auto;
}

.extensionIcon {
	width: 24px;
	height: 24px;
}
